module.exports = __webpack_public_path__ + "static/media/soap-and-shampoo.9aff312c.jpg";